import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "placeholder" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Placeholder',
  props: {
    label: {}
  },
  setup(__props: any) {

	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ph-dot" }, null, -1)),
    _createElementVNode("span", null, _toDisplayString(__props.label), 1)
  ]))
}
}

})